export default __webpack_public_path__ + "static/media/pink-outer.0745dc0e.svg";